import { faCheckCircle, faLock, faPlay } from '@fortawesome/free-solid-svg-icons';
import { Badge } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const getStatusIcon = (item: any, availableIcon = faPlay) => {
  if (item.completed) return faCheckCircle;
  if (!item.accessible) return faLock;
  return availableIcon;
};

const StatusBadge = ({ completed, status, className = '' }) => {
  const { t } = useTranslation();

  return (
    <Badge className={className} variant={completed ? 'success' : 'danger'}>
      {t(status)}
    </Badge>
  );
};

export { getStatusIcon, StatusBadge };
